import { React, useState } from "react";
import axios from "axios";
import { environmentVariables } from './config/env.config';

export const ApiHelper = async (apiUrl, method) => {
  try {
    const config = {
      url: apiUrl,
      method: method,
    };
    const response = await axios.request(config);
    return response;
  } catch (error) {
    console.log("error", error);
    return error?.response?.data?.message;
  }
};
export const ApiHelperID = async (method, apiUrl, id) => {
  try {
    const config = {
      url: `${apiUrl}?id=${id}`,
      method: method,
    };
    const response = await axios.request(config);
    return response;
  } catch (error) {
    console.log("error", error);
    return error?.response?.data?.message;
  }
};

 export const fetchBlogs = async () => {
    try {
      const response = await axios.get(
        `${environmentVariables?.apiUrlBlogs}api/v1/user/get-all-blogs`,
        { params: { type: 'be' } }
      );

      // console.log("Full API Response:", response);

      if (response?.data?.statusCode === 200 ) {
        // console.log("Blogs Data:", response.data.data);
        return response
      } else {
        console.error("API Error:", response.data?.message);
        return response
      }
    } catch (error) {
      return error?.response?.data
    }
  };
